<luigi-container
  id="dcp-private-offer-form-modal"
  [viewurl]="url()"
  webcomponent='{ "selfRegistered": true}'
  [context]="context"
></luigi-container>


